import axios from "axios";
import Swal from "sweetalert2";

const API_URL = "https://rscoreapi.azurewebsites.net/api/";
//const API_URL = "https://testrsapi.realtyspacehub.com/api/";

const axiosApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    //"Access-Control-Allow-Origin": "*",

  },
});

// ---------------- SESSION EXPIRED HANDLER ----------------

const AUTH_PATHS = ["/login", "/forgot-password", "/resetpassword", "/change-password"];

const ERROR_PAGES = {
  400: "/error-400",
  403: "/error-403",
  500: "/error-500",
};

function isAuthPage() {
  const path = window.location.pathname?.toLowerCase() || "";
  return AUTH_PATHS.some((p) => path === p || path.startsWith(p + "/"));
}

function isErrorPage() {
  const path = window.location.pathname?.toLowerCase() || "";
  return Object.values(ERROR_PAGES).some(
    (p) => path === p || path.startsWith(p + "/")
  );
}

function redirectToErrorPage(status) {
  const target = ERROR_PAGES[status];
  if (!target || isErrorPage()) return;
  window.location.href = target;
}

function showSessionExpiredAlert() {
  if (isAuthPage()) return;

  Swal.fire({
    title: "Session Expired",
    text: "Your session has expired. Please login again.",
    icon: "warning",
    confirmButtonText: "OK",
    allowOutsideClick: false,
    allowEscapeKey: false,
  }).then(() => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  });
}

// ---------------- RESPONSE INTERCEPTOR ----------------
async function sendErrorEmail(error, requestConfig) {
  try {
    await post(`${API_URL}APIError`, {
      apiUrl: requestConfig?.url || "",
      apiMethod: requestConfig?.method || "",
      apiErrorMessage: error.message,
      status: error.response?.status,
      apiErrorMessage: error.response?.data || null,
      agentId: parseInt(localStorage.getItem("userId")) || 0,
    });

  } catch (e) {
    console.error("Failed to send error email:", e);
  }
}
axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !isAuthPage()) {
        showSessionExpiredAlert();
    }

    const status = error.response?.status;
    if (status === 500) {
      try {
        //sendErrorEmail(error, error.response.config);
        //redirectToErrorPage(500);
      } catch (e) {
        /* ignore redirect/email failures */
      }
    } else if (status === 403) {
      //redirectToErrorPage(403);
    } else if (status === 400) {
      //redirectToErrorPage(400);
    }

    return Promise.reject(error);
  }
);

// ---------------- API HELPERS ----------------

export async function get(url, config = {}) {
  const response = await axiosApi.get(url, config);
  return response.data;
}

export async function post(url, data, config = {}) {
  const response = await axiosApi.post(url, data, config);
  return response.data;
}

export async function put(url, data, config = {}) {
  const response = await axiosApi.put(url, data, config);
  return response.data;
}

export async function del(url, config = {}) {
  const response = await axiosApi.delete(url, config);
  return response.data;
}

export default axiosApi;
